import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Fade from '@mui/material/Fade';
import Modal from '@mui/material/Modal';
import React from 'react';
import { immersightBlue } from '../../utils/colors';

export function LoadingModal({ open }: { open: boolean }) {
  return (
    <Modal
      open={open}
      closeAfterTransition
      disableAutoFocus
      disableEnforceFocus
      disableRestoreFocus
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
        sx: { backgroundColor: 'rgba(0,0,0,0.5)' },
      }}
      sx={{ outline: 'none' }}
    >
      <Fade in={open}>
        <Box
          tabIndex={-1} // required to strip focus styling
          sx={{
            position: 'absolute' as const,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'transparent',
            boxShadow: 'none',
            border: 'none',
            p: 0,
            outline: 'none',
          }}
        >
          <CircularProgress disableShrink size={60} sx={{ color: immersightBlue }} />
        </Box>
      </Fade>
    </Modal>
  );
}